module.exports = __webpack_public_path__ + "img/noI_leaf_turquoise.4391ac4e.png";